import React, { Component } from 'react';

class Tabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeIndex: 0,
    };
  }

  switchTab = (index) => {
    this.setState({
      activeIndex: index,
    });

  };

  render() {
    const { activeIndex } = this.state;
    const { children } = this.props;

    return (
      <div className="tabs">
        <div className="tabs__buttons">
          {children.map((tab, index) => (<button
            type="button"
            key={index}
            className={index === activeIndex ? 'tabs__buttons__button active' : 'tabs__buttons__button'}
            onClick={() => this.switchTab(index)}
          >
            <span className="title">{tab.props.name}</span>
            <span className="body">{tab.props.body}</span>
          </button>))}
        </div>

        <div className="tabs__contents">
          {children.map((tab, index) => (<div
            className={index === activeIndex ? 'tabs__contents__content active' : 'tabs__contents__content'}
            key={index}
          >{tab.props.children}</div>))}
        </div>
      </div>
    );
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/routes/calculator/Tabs.js